import { defineMessages } from 'react-intl'

export default defineMessages({
  featureName: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.FeatureName',
    defaultMessage: 'Name'
  },
  triggerData: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.triggerData',
    defaultMessage: 'Payload Data'
  },
  defaultTriggerData: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.triggerEventData',
    defaultMessage: 'Notification event data'
  },
  userID: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.user',
    defaultMessage: 'User Id'
  },
  userEmail: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.userEmail',
    defaultMessage: 'User email'
  },
  actionLabel: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.actionLabel',
    defaultMessage: 'Action Label'
  },
  attributeNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.eventData.attributeName',
    defaultMessage: 'Enter an attribute name'
  },
  attributeValueRequired: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.eventData.attributeValueRequired',
    defaultMessage: 'Enter an attribute value'
  },
  save: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.save',
    defaultMessage: 'Save'
  },
  cancel: {
    id: 'SpaceAppBuilderFeaturesPage.CreateActionFeatureModal.Cancel',
    defaultMessage: 'Cancel'
  }
})
